import logger from './logger';

/**
 * SDK URL Helper
 * Constructs SDK URLs correctly, handling the case where baseUrl may already include /api
 * 
 * @param {string} baseUrl - Base URL (may or may not include /api)
 * @param {...string} pathParts - SDK path components (e.g., 'bots', botId, 'widget')
 * @returns {string} Complete SDK URL
 * 
 * @example
 * // Localhost (baseUrl has no /api)
 * buildSdkUrl('http://localhost:8000', 'bots', 'demo', 'widget')
 * // Returns: 'http://localhost:8000/api/v1/sdk/bots/demo/widget'
 * 
 * @example
 * // Cloud (baseUrl already has /api)
 * buildSdkUrl('https://devmainalphaflex.azurewebsites.net/api', 'bots', 'demo', 'widget')
 * // Returns: 'https://devmainalphaflex.azurewebsites.net/api/v1/sdk/bots/demo/widget'
 */
export function buildSdkUrl(baseUrl, ...pathParts) {
  if (!baseUrl) {
    logger.error('SDK-URL-HELPER', 'baseUrl is required');
    return '';
  }
  if (typeof baseUrl === 'string' && baseUrl.includes('blob.core.windows.net')) {
    logger.error('SDK-URL-HELPER', 'baseUrl must not be blob storage; SDK is served from API endpoint only', { rejected: baseUrl });
    throw new Error(
      'SDK URL must use the API endpoint, not blob storage. Ensure getApiEndpoint returns the API base URL (e.g. https://api..../api).'
    );
  }
  
  const hasApiPrefix = baseUrl && (baseUrl.endsWith('/api') || baseUrl.match(/\/api\/?$/));
  const sdkPath = pathParts.filter(Boolean).join('/');
  
  if (!sdkPath) {
    logger.error('SDK-URL-HELPER', 'SDK path is required');
    return baseUrl;
  }
  
  if (hasApiPrefix) {
    const url = `${baseUrl}/v1/sdk/${sdkPath}`;
    logger.debug('SDK-URL-HELPER', 'baseUrl has /api', { url });
    return url;
  } else {
    const url = `${baseUrl}/api/v1/sdk/${sdkPath}`;
    logger.debug('SDK-URL-HELPER', 'baseUrl missing /api (localhost)', { url });
    return url;
  }
}












